// extracted by mini-css-extract-plugin
export default {"container":"TcpQg6X8KTuWSkvo3a4h"};